import { ACTIONS } from "@/app/components/payment/actions";
import { OrderDetails } from "@/app/interface/digio";
import { NEFTAccount, PaymentModes } from "@/context/TransactionContext";

// Transaction states
export const TRANSACTION_STATES = {
    DIGIO_FLOW: "DIGIO_FLOW",
    PAYMENT_CHOICE: "PAYMENT_CHOICE",
    COMPLETED: "COMPLETED",
    FAILED: "FAILED",
    ERROR: "ERROR",
} as const;

type TransactionState = {
    currentState: keyof typeof TRANSACTION_STATES;
    productCode: string | null;
    isin: string | null;
    paymentType: string | null;
    orderId: string | null;
    error: string | null;
    postDigioTxnData: OrderDetails | null;
    allowedTxnType: PaymentModes;
    NeftDetails: NEFTAccount | null;
};

type ActionType = {
    type: keyof typeof ACTIONS;
    payload?: Partial<TransactionState>;
};

// Initial state
const initialState: TransactionState = {
    currentState: TRANSACTION_STATES.DIGIO_FLOW,
    productCode: null,
    isin: null,
    paymentType: null,
    orderId: null,
    error: null,
    postDigioTxnData: null,
    allowedTxnType: {
        upi: true,
        neft: true,
        netbanking: true,
    },
    NeftDetails: null,
};

// Reducer function
export const transactionReducer = (
    state: TransactionState,
    action: ActionType,
): TransactionState => {
    switch (action.type) {
        case ACTIONS.SET_DIGIO_FLOW:
            return {
                ...state,
                currentState: TRANSACTION_STATES.DIGIO_FLOW,
                orderId: action.payload?.orderId || null,
                allowedTxnType: action?.payload?.allowedTxnType || state.allowedTxnType,
                NeftDetails: action?.payload?.NeftDetails || null,
            };
        case ACTIONS.SET_PAYMENT_CHOICE:
            return {
                ...state,
                currentState: TRANSACTION_STATES.PAYMENT_CHOICE,
                isin: action.payload?.isin || null,
                postDigioTxnData: action.payload?.postDigioTxnData || null,
            };
        case ACTIONS.SET_COMPLETED:
            return { ...state, currentState: TRANSACTION_STATES.COMPLETED };
        case ACTIONS.SET_ERROR:
            return {
                ...state,
                currentState: TRANSACTION_STATES.ERROR,
                orderId: action.payload?.orderId || null,
                error: action.payload?.error || "Transaction failed",
            };
        case ACTIONS.SET_FAILED:
            return {
                ...state,
                currentState: TRANSACTION_STATES.FAILED,
                error: action.payload?.error || "Transaction failed",
            };
        case ACTIONS.RESET:
            return initialState;
        default:
            return state;
    }
};
